import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const MarketFilters = ({ 
  selectedMarket, 
  onMarketChange, 
  selectedTimeframe, 
  onTimeframeChange,
  selectedDataSource,
  onDataSourceChange,
  onRefresh 
}) => {
  const marketOptions = [
    { value: 'all', label: 'All Markets' },
    { value: 'eua', label: 'EUA (EU Allowances)' },
    { value: 'oil', label: 'Oil Futures' },
    { value: 'correlation', label: 'EUA-Oil Correlation' }
  ];

  const timeframeOptions = [
    { value: '1h', label: 'Last Hour' },
    { value: '1d', label: 'Today' },
    { value: '1w', label: 'This Week' },
    { value: '1m', label: 'This Month' },
    { value: '3m', label: 'Last 3 Months' }
  ];

  const dataSourceOptions = [
    { value: 'all', label: 'All Sources' },
    { value: 'ice', label: 'ICE Exchange' },
    { value: 'nymex', label: 'NYMEX' },
    { value: 'reuters', label: 'Reuters' },
    { value: 'bloomberg', label: 'Bloomberg' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Market Filters</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onRefresh}
          iconName="RefreshCw"
          iconPosition="left"
        >
          Refresh
        </Button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          label="Market"
          options={marketOptions}
          value={selectedMarket}
          onChange={onMarketChange}
          className="w-full"
        />
        
        <Select
          label="Timeframe"
          options={timeframeOptions}
          value={selectedTimeframe}
          onChange={onTimeframeChange}
          className="w-full"
        />
        
        <Select
          label="Data Source"
          options={dataSourceOptions}
          value={selectedDataSource}
          onChange={onDataSourceChange}
          className="w-full"
        />
      </div>
    </div>
  );
};

export default MarketFilters;